import { IconContext } from 'react-icons'
import { HiSearch } from 'react-icons/hi'
const { useState } = wp.element
// eslint-disable-next-line no-undef
const { homeUrl } = MH

const SearchField = (props) => {
  // props.inutEl.current.focus()
  return (
    <div className="search-field">
      <div className="search-field-inner max-w-3xl">
        <label className="form-label">検索ワードを入力</label>
        <form action={homeUrl}>
          <label htmlFor="search" className="screen-reader-text">Search</label>
          <div className="search-form form-with-icon">
            <div className="form-with-icon-inner">
              <HiSearch />
            </div>
            <input id="search" name="s" className="form-input" placeholder="サイト内検索" type="search" />
          </div>
        </form>
      </div>
    </div>
  )
}

const SearchButton = () => {
  const [showField, setShowField] = useState(false)

  const onClickButton = () => {
    setShowField(!showField)
  }

  return (
    <>
      <button onClick={() => onClickButton()} className="global-nav-button">
        <IconContext.Provider value={{ className: 'w-6 h-6' }}>
          <HiSearch />
        </IconContext.Provider>
      </button>
      { showField &&
      <SearchField />
      }
    </>
  )
}

export default SearchButton
